import React from 'react';

import SymbolOrderItem from './SymbolOrderItem';

import Icon from 'components/commons/icon/Icon';

import * as api from 'config/api';

type SymbolOrderListProps = {
  symbol: string;
  orders: Array<api.GetOrdersResultItem>;
  readMoreOrders: () => void;
  availableReadMore: boolean;
};

const SymbolOrderList: React.FC<SymbolOrderListProps> = ({
  symbol,
  orders,
  readMoreOrders,
  availableReadMore,
}) => {
  const ordersElemtns = orders.map((o, i, arr) => {
    const x = {
      date: o.TradeTime,
      symbol: o.Symbol,
      symbolName: o.SymbolName,
      brokerName: o.BrokerName,
      qty: o.Qty,
      price: o.Price,
      openPriceUSD: o.OpenPriceUSD,
      side: o.Side,
      tradeType: o.TradeType,
      accountType: o.AccountType,
      cashMargin: o.CashMargin,
      profitOrLoss: o.ProfitOrLoss,
      profitOrLossUSD: o.ProfitOrLossUSD,
      productType: o.ProductType,
      currencyUnit: o.CurrencyUnit,
    };
    return (
      <>
        <SymbolOrderItem {...x} key={i} />
        {i !== arr.length - 1 && (
          <div className="border-b border-gray-300 mx-2" />
        )}
      </>
    );
  });

  return (
    <div className="">
      {ordersElemtns}
      {availableReadMore ? (
        <div className="cursor-pointer" onClick={readMoreOrders}>
          <div className="my-3 flex items-center justify-center text-gray-500">
            <Icon name="chevron-down" className="text-lg" />
            <div className="ml-1 text-sm">取引履歴をさらに表示</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SymbolOrderList;
